import { render, staticRenderFns } from "./TentangPerdatin.vue?vue&type=template&id=44ab84ce"
import script from "./TentangPerdatin.vue?vue&type=script&lang=js"
export * from "./TentangPerdatin.vue?vue&type=script&lang=js"
import style0 from "./TentangPerdatin.vue?vue&type=style&index=0&id=44ab84ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports